// translation-dialog.component.ts
// Place this file at: src/app/shared/html-editor/translation/translation-dialog.component.ts

import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';

export interface TranslationDialogData {
  currentText: string;
  detectedLanguage?: string;
}

@Component({
  selector: 'app-translation-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule
  ],
  template: `
    <h2 mat-dialog-title>Translate Content</h2>
    <mat-dialog-content>
      <form [formGroup]="translationForm">
        <mat-form-field appearance="outline" style="width: 100%;padding-top:10px">
          <mat-label>Target Language</mat-label>
<mat-select formControlName="targetLanguage">
  <mat-option value="en">English</mat-option>
  <mat-option value="es">Spanish</mat-option>
  <mat-option value="fr">French</mat-option>
  <mat-option value="de">German</mat-option>
  <mat-option value="it">Italian</mat-option>
  <mat-option value="pt">Portuguese</mat-option>
  <mat-option value="zh">Chinese</mat-option>
  <mat-option value="ja">Japanese</mat-option>
  <mat-option value="ko">Korean</mat-option>
  <mat-option value="ar">Arabic</mat-option>
  <mat-option value="ru">Russian</mat-option>
  <mat-option value="hi">Hindi</mat-option>
</mat-select>
        </mat-form-field>
        
        <div class="language-info" *ngIf="data.detectedLanguage">
          <small>Detected language: {{ getLanguageName(data.detectedLanguage) }}</small>
        </div>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="cancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="translate()" [disabled]="!translationForm.valid">
        Translate
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content {
      min-width: 300px;
    }
    .language-info {
      margin-top: -10px;
      margin-bottom: 10px;
      color: #666;
    }
  `]
})
export class TranslationDialogComponent {
  translationForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<TranslationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TranslationDialogData,
    private fb: FormBuilder
  ) {
    this.translationForm = this.fb.group({
      targetLanguage: ['', Validators.required]
    });

    // Set default target language based on detected language
    if (data.detectedLanguage === 'en') {
      this.translationForm.patchValue({ targetLanguage: 'es' });
    } else {
      this.translationForm.patchValue({ targetLanguage: 'en' });
    }
  }

  translate(): void {
    if (this.translationForm.valid) {
      this.dialogRef.close(this.translationForm.value);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }

  getLanguageName(code: string): string {
    const languages: { [key: string]: string } = {
      'en': 'English',
      'es': 'Spanish',
      'fr': 'French',
      'de': 'German',
      'it': 'Italian',
      'pt': 'Portuguese',
      'zh': 'Chinese',
      'ja': 'Japanese',
      'ko': 'Korean',
      'ar': 'Arabic',
      'hi': 'Hindi',
      'ru': 'Russian'
    };
    return languages[code] || code.toUpperCase();
  }
}